import {
  API_PROPITIOUS_AREA_JOB_ROUTE,
  API_PROPITIOUS_AREA_JOBS_ROUTE,
} from "../global/constants/routes/apiConstants";
import {
  CreatePropitiousAreaJobPayload,
  ListPropitiousAreaJobsParams,
  PropitiousAreaJobListResponse,
  PropitiousAreaJobResponse,
} from "../global/types/propitiousAreaJob";
import { apiService } from "./api";

export const createPropitiousAreaJob = async (
  payload: CreatePropitiousAreaJobPayload
): Promise<PropitiousAreaJobResponse> => {
  const response = await apiService.post<PropitiousAreaJobResponse>(
    API_PROPITIOUS_AREA_JOBS_ROUTE,
    payload
  );
  return response.data;
};

export const listPropitiousAreaJobs = async ({
  status,
  offset = 0,
  limit = 25,
}: ListPropitiousAreaJobsParams = {}): Promise<PropitiousAreaJobListResponse> => {
  const response = await apiService.get<PropitiousAreaJobListResponse>(
    API_PROPITIOUS_AREA_JOBS_ROUTE,
    { params: { status, offset, limit } }
  );
  return response.data;
};

export const getPropitiousAreaJob = async (
  id: number
): Promise<PropitiousAreaJobResponse> => {
  const response = await apiService.get<PropitiousAreaJobResponse>(
    API_PROPITIOUS_AREA_JOB_ROUTE(id)
  );
  return response.data;
};
